import { FullScreenModal } from "@circle-react-shared/ModalsV2/FullScreenModal";
import { Suspense } from "react";

import { lazyWithRetry } from "@/react/helpers/lazyRetry";
import { PageLoader } from "@/react/pages/PageLoader";

const LiveFormV3Content = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "LiveFormV3Content" */ "./LiveFormV3Content"
  ).then(module => ({
    default: module.LiveFormV3Content,
  })),
);

interface LiveFormV3Props {
  isOpen: boolean;
  onClose: () => void;
}

export const LiveFormV3 = ({ isOpen, onClose }: LiveFormV3Props) => (
  <FullScreenModal
    isOpen={isOpen}
    onClose={onClose}
    shouldShowCloseButton
    contentPortalId="live"
  >
    <Suspense fallback={<PageLoader />}>
      <LiveFormV3Content onClose={onClose} />
    </Suspense>
  </FullScreenModal>
);
